import "./About.css";
import aboutImage1 from "../../assets/Mario and Adrian A.jpg";
import aboutImage2 from "../../assets/Mario and Adrian b.jpg";

export default function About() {
  return (
    <section id="about">
      <div className="container grid">
        <article id="about-description">
          <h1 style={{ color: "#F4CE14" }}>Little Lemon</h1>
          <h2>Chicago</h2>
          <p style={{ paddingTop: "1.5rem" }}>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet. Amet minim mollit non deserunt
            ullamco est sit aliqua dolor do amet sint. Velit officia consequat
            duis enim velit mollit.
          </p>
        </article>
        <div id="about-images">
          <img
            className="about-image-primary"
            src={aboutImage1}
            alt="Chefs Mario and Adrian A"
          />
          <img
            className="about-image-secondary"
            src={aboutImage2}
            alt="Chefs Mario and Adrian B"
          />
        </div>
      </div>
    </section>
  );
}
